import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import EXHALE from '@/lib/testIds';

/**
 * SettingsDialog — three soft toggles. Nothing more.
 */
export default function SettingsDialog({ open, onOpenChange, settings, onChange }) {
  const set = (key) => (val) => onChange({ ...settings, [key]: val });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={EXHALE.settingsDialog}
        className="max-w-md border-0 bg-background sm:rounded-lg"
      >
        <DialogHeader className="text-left">
          <DialogTitle className="font-serif text-2xl font-light">
            A few quiet preferences
          </DialogTitle>
          <DialogDescription className="text-muted-foreground">
            Adjust at any time. Nothing is shared.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 space-y-6">
          <div className="flex items-center justify-between">
            <div className="pr-6">
              <Label htmlFor="breathing" className="text-base">Breathing cue</Label>
              <p className="text-sm text-muted-foreground mt-1">
                A soft visual rhythm behind the page.
              </p>
            </div>
            <Switch
              id="breathing"
              data-testid={EXHALE.toggleBreathing}
              checked={settings.breathing}
              onCheckedChange={set('breathing')}
            />
          </div>

          <div className="flex items-center justify-between">
            <div className="pr-6">
              <Label htmlFor="sound" className="text-base">Ambient sound</Label>
              <p className="text-sm text-muted-foreground mt-1">
                Off by default. A low, warm hum if you want it.
              </p>
            </div>
            <Switch
              id="sound"
              data-testid={EXHALE.toggleSound}
              checked={settings.ambientSound}
              onCheckedChange={set('ambientSound')}
            />
          </div>

          <div className="flex items-center justify-between">
            <div className="pr-6">
              <Label htmlFor="reflections" className="text-base">Reflections</Label>
              <p className="text-sm text-muted-foreground mt-1">
                One quiet sentence after you finish, if you'd like.
              </p>
            </div>
            <Switch
              id="reflections"
              data-testid={EXHALE.toggleReflections}
              checked={settings.reflections}
              onCheckedChange={set('reflections')}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
